<template>
  <div>
    <div class="wrapper">
      <!-- TOP Nav Bar -->
      <!-- Right Sidebar Panel End-->
      <!-- TOP Nav Bar END -->
      <div id="content-page" class="content-page ">
        <div class="container-fluid p-30px">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { socialvue } from "../config/pluginInit"
export default {
  name: "ContentLayout",
  components: {
  },
  data () {
    return {
      logo: require("../assets_gide/img/logo/gide_logo.png")
    }
  },
  mounted () {
    socialvue.mainIndex()
  }
}
</script>
<style>
  @import url("../assets/css/custom.css");
</style>
